var _polygon, _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4, _polygon2, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaintenance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.67,166.65a2.65,2.65,0,0,1,2.78,0l.72.41.74.37a2.64,2.64,0,0,1,1.55,2.3l.11,3.43,11.16-.35-.11-3.42A2.65,2.65,0,0,1,80,167c.48-.27,1-.56,1.41-.88a2.64,2.64,0,0,1,2.77-.17l3,1.61,5.28-9.84-3-1.62a2.65,2.65,0,0,1-1.38-2.41,15.35,15.35,0,0,0-.06-1.66,2.68,2.68,0,0,1,1.23-2.5l2.92-1.81-5.89-9.49-2.93,1.82a2.68,2.68,0,0,1-2.77,0c-.24-.14-.47-.28-.72-.41l-.73-.37a2.67,2.67,0,0,1-1.56-2.31l-.1-3.43-11.16.35.1,3.41a2.63,2.63,0,0,1-1.39,2.41,14.65,14.65,0,0,0-1.42.88,2.68,2.68,0,0,1-2.78.18l-3-1.62L52.56,149l3,1.62A2.66,2.66,0,0,1,57,153a13.37,13.37,0,0,0,0,1.67,2.64,2.64,0,0,1-1.23,2.49L52.87,159l5.89,9.49ZM64.46,149a9.15,9.15,0,1,1,3.75,12.39A9.16,9.16,0,0,1,64.46,149Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.32,84.94a1.89,1.89,0,0,1,.91,1.73c0,.19,0,.38,0,.58s0,.38,0,.58a1.87,1.87,0,0,1-.91,1.72l-2.08,1.2,3.91,6.77,2.08-1.2a1.87,1.87,0,0,1,1.95.07,10.23,10.23,0,0,0,1,.59,1.87,1.87,0,0,1,1,1.65V101H427v-2.4a1.87,1.87,0,0,1,1-1.65,10.23,10.23,0,0,0,1-.59,1.87,1.87,0,0,1,1.95-.07l2.08,1.2L437,90.75l-2.09-1.21a1.84,1.84,0,0,1-.9-1.72c0-.19,0-.38,0-.57s0-.39,0-.58a1.87,1.87,0,0,1,.91-1.73l2.08-1.2L433.11,77,431,78.17a1.87,1.87,0,0,1-2-.07c-.33-.21-.67-.41-1-.59a1.86,1.86,0,0,1-1-1.65V73.47h-7.82v2.39a1.86,1.86,0,0,1-1,1.65c-.35.18-.69.38-1,.59a1.87,1.87,0,0,1-1.95.07L413.15,77l-3.91,6.77Zm11.81-4.11a6.41,6.41,0,1,1-6.41,6.42A6.42,6.42,0,0,1,423.13,80.83Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.52,234.06A30.47,30.47,0,1,0,430,203.59,30.47,30.47,0,0,0,399.52,234.06Zm16.23,0A14.24,14.24,0,1,1,430,248.29,14.24,14.24,0,0,1,415.75,234.06Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "424.13 204.85 435.85 204.85 435.2 196.56 424.78 196.56 424.13 204.85",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "446.43 208.8 454.72 217.09 460.13 210.76 452.75 203.39 446.43 208.8",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "459.41 227.36 459.41 239.08 467.71 238.43 467.71 228.01 459.41 227.36",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "455.46 249.67 447.18 257.95 453.5 263.36 460.87 255.99 455.46 249.67",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.9 262.65 425.18 262.65 425.83 270.94 436.25 270.94 436.9 262.65",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "414.6 258.7 406.31 250.41 400.9 256.74 408.27 264.11 414.6 258.7",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.62 240.14 401.62 228.42 393.32 229.06 393.32 239.49 401.62 240.14",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.56 217.83 413.85 209.55 407.53 204.14 400.16 211.51 405.56 217.83",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.3,211.19a30.48,30.48,0,1,0,30.48-30.47A30.48,30.48,0,0,0,104.3,211.19Zm16.24,0a14.24,14.24,0,1,1,14.24,14.22A14.25,14.25,0,0,1,120.54,211.19Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.92 181.98 140.63 181.98 139.99 173.68 129.56 173.68 128.92 181.98",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.22 185.93 159.51 194.21 164.91 187.89 157.54 180.52 151.22 185.93",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.2 204.49 164.2 216.21 172.5 215.56 172.5 205.14 164.2 204.49",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.25 226.79 151.97 235.08 158.29 240.49 165.66 233.12 160.25 226.79",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.69 239.77 129.97 239.77 130.62 248.07 141.04 248.07 141.69 239.77",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "119.39 235.82 111.1 227.54 105.69 233.86 113.06 241.23 119.39 235.82",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.41 217.26 106.41 205.54 98.11 206.19 98.11 216.61 106.41 217.26",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.36 194.96 118.64 186.67 112.32 181.26 104.95 188.63 110.36 194.96",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.18 330.93 200.07 337.72 198.88 345.01 188.04 411.51 170.3 411.51 181.15 345.01 182.34 337.72 183.44 330.93 201.18 330.93",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.61,330.93c-.94,6.74-1.94,13.46-3,20.19l-3.12,20.15-3.28,20.14-1.69,10-1.76,10.05,1.44-10.1,1.51-10.08,3.13-20.16L195.16,351C196.28,344.33,197.41,337.63,198.61,330.93Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.07 337.72 198.88 345.01 181.15 345.01 182.34 337.72 200.07 337.72",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.74 330.93 289.84 337.72 291.03 345.01 301.87 411.51 319.61 411.51 308.76 345.01 307.58 337.72 306.47 330.93 288.74 330.93",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.36,330.93c.93,6.74,1.94,13.46,3,20.19l3.12,20.15,3.28,20.14,1.69,10,1.76,10.05-1.44-10.1-1.51-10.08-3.13-20.16L294.81,351C293.69,344.33,292.56,337.63,291.36,330.93Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.84 337.72 307.58 337.72 308.76 345.01 291.03 345.01 289.84 337.72",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.53 312.23 186.47 312.23 188.22 299.12 198.78 299.12 200.53 312.23",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.61,289.75a13.11,13.11,0,1,1-13.11-13.11A13.1,13.1,0,0,1,206.61,289.75Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.46,289.75a10,10,0,1,1-10-10A10,10,0,0,1,203.46,289.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.83,289.17a8.64,8.64,0,0,0-3.26-6.11,8.78,8.78,0,0,0-6.7-1.76,8.45,8.45,0,0,0-5.76,3.75,8.81,8.81,0,0,0-1.05,7.18,8.28,8.28,0,0,0,3.89,4.93,8.72,8.72,0,0,0,6.1.94,9,9,0,0,0,5.12-3.14,9.39,9.39,0,0,0,2.1-5.55c0-.09,0-.17-.07-.18s-.09.08-.1.18a8.59,8.59,0,0,1-.47,2.4,9.56,9.56,0,0,1-1.1,2.16,9.88,9.88,0,0,1-1.63,1.79,10.64,10.64,0,0,1-2.07,1.34,8.31,8.31,0,0,1-6.8.16,8.15,8.15,0,0,1-4.61-5.06,8.45,8.45,0,0,1,.87-7,8.06,8.06,0,0,1,5.61-3.69,8.64,8.64,0,0,1,8.25,3.29,8.42,8.42,0,0,1,1.11,2.07,10,10,0,0,1,.53,2.31s0,0,0,0S201.83,289.2,201.83,289.17Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.66,289.18a7.46,7.46,0,0,0-2.82-5.22,7.67,7.67,0,0,0-5.73-1.52,7.24,7.24,0,0,0-5,3.18,7.62,7.62,0,0,0-1,6.22,7.13,7.13,0,0,0,3.38,4.31,7.52,7.52,0,0,0,5.32.8,7.86,7.86,0,0,0,4.43-2.75,8.32,8.32,0,0,0,1.82-4.81c0-.08,0-.15-.08-.16s-.09.07-.1.15a7.91,7.91,0,0,1-4.55,6.64,7.14,7.14,0,0,1-5.88.17,7,7,0,0,1-4-4.39,7.3,7.3,0,0,1,.8-6,6.93,6.93,0,0,1,4.83-3.11,7.5,7.5,0,0,1,7,2.79,8.18,8.18,0,0,1,1,1.76,9.52,9.52,0,0,1,.47,2s0,0,0,0S200.67,289.2,200.66,289.18Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.49,289.19a6.25,6.25,0,0,0-2.39-4.32,6.49,6.49,0,0,0-4.74-1.29,6.07,6.07,0,0,0-4.21,2.61,6.49,6.49,0,0,0-.89,5.27,5.93,5.93,0,0,0,2.87,3.68,6.39,6.39,0,0,0,4.54.66,6.69,6.69,0,0,0,3.74-2.36,7.18,7.18,0,0,0,1.53-4.07.12.12,0,0,0-.08-.14s-.09.06-.09.13a6.8,6.8,0,0,1-3.84,5.59,6,6,0,0,1-5,.18,5.88,5.88,0,0,1-3.36-3.73,6.09,6.09,0,0,1,.72-5,5.74,5.74,0,0,1,4.06-2.54,7,7,0,0,1,3.21.38,6.14,6.14,0,0,1,2.61,1.92,6.93,6.93,0,0,1,.82,1.45,7.39,7.39,0,0,1,.42,1.65s0,0,0,0S199.5,289.21,199.49,289.19Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.33,289.2a5.18,5.18,0,0,0-2-3.43,5.35,5.35,0,0,0-3.77-1,4.89,4.89,0,0,0-3.44,2,5.3,5.3,0,0,0-.8,4.3,4.84,4.84,0,0,0,2.35,3.06,5.17,5.17,0,0,0,3.76.52,5.44,5.44,0,0,0,3.05-2,5.94,5.94,0,0,0,1.26-3.33.1.1,0,0,0-.08-.11s-.09,0-.1.11a5.65,5.65,0,0,1-3.11,4.53,4.86,4.86,0,0,1-4.05.19,4.71,4.71,0,0,1-2.73-3.06,4.9,4.9,0,0,1,.64-4.08,4.59,4.59,0,0,1,3.28-2,5.91,5.91,0,0,1,2.53.32,5,5,0,0,1,2.08,1.49,5.46,5.46,0,0,1,.68,1.14,7.64,7.64,0,0,1,.37,1.31,0,0,0,0,0,0,0S198.33,289.21,198.33,289.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.14 312.23 289.08 312.23 290.83 299.12 301.39 299.12 303.14 312.23",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.22,289.75a13.11,13.11,0,1,1-13.11-13.11A13.1,13.1,0,0,1,309.22,289.75Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.07,289.75a10,10,0,1,1-10-10A10,10,0,0,1,306.07,289.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.44,289.17a8.64,8.64,0,0,0-3.26-6.11,8.78,8.78,0,0,0-6.7-1.76,8.45,8.45,0,0,0-5.76,3.75,8.81,8.81,0,0,0-1.05,7.18,8.28,8.28,0,0,0,3.89,4.93,8.72,8.72,0,0,0,6.1.94,9,9,0,0,0,5.12-3.14,9.39,9.39,0,0,0,2.1-5.55c0-.09,0-.17-.07-.18s-.09.08-.1.18a8.59,8.59,0,0,1-.47,2.4,9.16,9.16,0,0,1-1.1,2.16,9.88,9.88,0,0,1-1.63,1.79,10.64,10.64,0,0,1-2.07,1.34,8.31,8.31,0,0,1-6.8.16A8.15,8.15,0,0,1,288,292.2a8.45,8.45,0,0,1,.87-7,8.06,8.06,0,0,1,5.61-3.69,8.64,8.64,0,0,1,8.25,3.29,8.42,8.42,0,0,1,1.11,2.07,10,10,0,0,1,.53,2.31s0,0,0,0S304.44,289.2,304.44,289.17Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.27,289.18a7.46,7.46,0,0,0-2.82-5.22,7.67,7.67,0,0,0-5.73-1.52,7.24,7.24,0,0,0-5,3.18,7.62,7.62,0,0,0-1,6.22,7.13,7.13,0,0,0,3.38,4.31,7.52,7.52,0,0,0,5.32.8,7.86,7.86,0,0,0,4.43-2.75,8.32,8.32,0,0,0,1.82-4.81c0-.08,0-.15-.08-.16s-.09.07-.1.15A7.91,7.91,0,0,1,299,296a7.14,7.14,0,0,1-5.88.17,7,7,0,0,1-4-4.39,7.3,7.3,0,0,1,.8-6,6.93,6.93,0,0,1,4.83-3.11,7.5,7.5,0,0,1,7,2.79,8.18,8.18,0,0,1,1,1.76,9.52,9.52,0,0,1,.47,2s0,0,0,0S303.28,289.2,303.27,289.18Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.1,289.19a6.25,6.25,0,0,0-2.39-4.32,6.49,6.49,0,0,0-4.74-1.29,6.07,6.07,0,0,0-4.21,2.61,6.49,6.49,0,0,0-.89,5.27,5.93,5.93,0,0,0,2.87,3.68,6.39,6.39,0,0,0,4.54.66,6.69,6.69,0,0,0,3.74-2.36,7.18,7.18,0,0,0,1.53-4.07.12.12,0,0,0-.08-.14s-.09.06-.09.13a6.78,6.78,0,0,1-3.84,5.59,6,6,0,0,1-5,.18,5.88,5.88,0,0,1-3.36-3.73,6.09,6.09,0,0,1,.72-5,5.74,5.74,0,0,1,4.06-2.54,7,7,0,0,1,3.21.38,6.14,6.14,0,0,1,2.61,1.92,6.93,6.93,0,0,1,.82,1.45,7.39,7.39,0,0,1,.42,1.65s0,0,0,0S302.11,289.21,302.1,289.19Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.94,289.2a5.18,5.18,0,0,0-2-3.43,5.35,5.35,0,0,0-3.77-1,4.89,4.89,0,0,0-3.44,2,5.3,5.3,0,0,0-.8,4.3,4.84,4.84,0,0,0,2.35,3.06,5.17,5.17,0,0,0,3.76.52,5.5,5.5,0,0,0,3.06-2,6,6,0,0,0,1.25-3.33.1.1,0,0,0-.08-.11c-.05,0-.09,0-.1.11a5.65,5.65,0,0,1-3.11,4.53,4.86,4.86,0,0,1-4.05.19,4.71,4.71,0,0,1-2.73-3.06,4.9,4.9,0,0,1,.64-4.08,4.59,4.59,0,0,1,3.28-2,5.91,5.91,0,0,1,2.53.32,5,5,0,0,1,2.08,1.49,5.46,5.46,0,0,1,.68,1.14,7.64,7.64,0,0,1,.37,1.31,0,0,0,0,0,0,0S300.94,289.21,300.94,289.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.59,
    y: 305.54,
    width: 176.72,
    height: 33.8,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.92 305.54 180.09 339.35 157.27 339.35 170.09 305.54 192.92 305.54",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.7 305.54 226.88 339.35 204.04 339.35 216.87 305.54 239.7 305.54",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.48 305.54 273.65 339.35 250.83 339.35 263.65 305.54 286.48 305.54",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.26 305.54 320.43 339.35 297.6 339.35 310.43 305.54 333.26 305.54",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.17,
    y: 370.6,
    width: 169.57,
    height: 21.39,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.02 370.6 182.72 391.99 160.82 391.99 173.13 370.6 195.02 370.6",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.91 370.6 227.61 391.99 205.7 391.99 218.01 370.6 239.91 370.6",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.8 370.6 272.49 391.99 250.59 391.99 262.9 370.6 284.8 370.6",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.69 370.6 317.38 391.99 295.47 391.99 307.78 370.6 329.69 370.6",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 448.36,
    rx: 208.86,
    ry: 17.45,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "30.64 411.51 85.48 411.27 140.32 411.18 250 411.01 359.68 411.18 414.52 411.27 469.36 411.51 414.52 411.76 359.68 411.84 250 412.01 140.32 411.84 85.48 411.75 30.64 411.51",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.26,123.39a31.47,31.47,0,1,0,31.47-31.46A31.47,31.47,0,0,0,338.26,123.39Zm16.77,0a14.7,14.7,0,1,1,14.7,14.69A14.7,14.7,0,0,1,355,123.39Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.68 93.23 375.77 93.23 375.11 84.67 364.35 84.67 363.68 93.23",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.7 97.31 395.26 105.86 400.84 99.33 393.23 91.72 386.7 97.31",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400.11 116.47 400.11 128.57 408.67 127.91 408.67 117.14 400.11 116.47",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.03 139.5 387.48 148.06 394 153.64 401.61 146.03 396.03 139.5",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.86 152.91 364.76 152.91 365.43 161.47 376.19 161.47 376.86 152.91",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353.83 148.83 345.28 140.27 339.7 146.8 347.31 154.41 353.83 148.83",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.43 129.66 340.43 117.56 331.87 118.23 331.87 128.99 340.43 129.66",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.51 106.63 353.06 98.08 346.54 92.49 338.93 100.1 344.51 106.63",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.83,116.29l-9.71-2.6L360,120.8l2.6,9.69,9.7,2.6,7.11-7.1Zm-7.1,10.28a3.18,3.18,0,1,1,3.18-3.18A3.18,3.18,0,0,1,369.73,126.57Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,197a31.29,31.29,0,1,0,31.28-31.3A31.33,31.33,0,0,0,266,197Zm6.66,0a24.64,24.64,0,1,1,24.62,24.63A24.62,24.62,0,0,1,272.68,197ZM266,197a31.29,31.29,0,1,0,31.28-31.3A31.33,31.33,0,0,0,266,197Zm6.66,0a24.64,24.64,0,1,1,24.62,24.63A24.62,24.62,0,0,1,272.68,197Zm-28.12,0A52.75,52.75,0,1,0,297.3,144.2,52.74,52.74,0,0,0,244.56,197ZM263,197a34.3,34.3,0,1,1,34.28,34.29A34.34,34.34,0,0,1,263,197Zm3,0a31.29,31.29,0,1,0,31.28-31.3A31.33,31.33,0,0,0,266,197Zm6.66,0a24.64,24.64,0,1,1,24.62,24.63A24.62,24.62,0,0,1,272.68,197Z",
    style: {
      fill: "#00D35C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.12 145.15 303.2 145.15 301.99 133.1 292.32 133.1 291.12 145.15",
    style: {
      fill: "#00D35C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.85 149 328.31 155.03 333.29 143.99 324.92 139.16 317.85 149",
    style: {
      fill: "#00D35C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.07 165.69 345.11 176.15 354.95 169.08 350.12 160.7 339.07 165.69",
    style: {
      fill: "#00D35C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.11 190.76 349.11 202.84 361.17 201.63 361.17 191.96 349.11 190.76",
    style: {
      fill: "#00D35C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.27 217.49 339.23 227.95 350.27 232.93 355.11 224.56 345.27 217.49",
    style: {
      fill: "#00D35C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.58 238.71 318.12 244.75 325.19 254.59 333.56 249.76 328.58 238.71",
    style: {
      fill: "#00D35C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.51 248.75 291.43 248.75 292.63 260.81 302.31 260.81 303.51 248.75",
    style: {
      fill: "#00D35C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.78 244.91 266.32 238.87 261.33 249.91 269.71 254.75 276.78 244.91",
    style: {
      fill: "#00D35C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.55 228.22 249.51 217.76 239.67 224.83 244.51 233.2 255.55 228.22",
    style: {
      fill: "#00D35C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.51 203.15 245.51 191.07 233.46 192.27 233.46 201.94 245.51 203.15",
    style: {
      fill: "#00D35C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.36 176.42 255.4 165.96 244.35 160.97 239.52 169.35 249.36 176.42",
    style: {
      fill: "#00D35C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.05 155.19 276.51 149.15 269.44 139.31 261.06 144.15 266.05 155.19",
    style: {
      fill: "#00D35C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.75,113.64a14.36,14.36,0,1,0-13-15.63A14.35,14.35,0,0,0,126.75,113.64ZM115.53,98.18a12.6,12.6,0,1,1,11.37,13.71A12.59,12.59,0,0,1,115.53,98.18Zm11.22,15.46a14.36,14.36,0,1,0-13-15.63A14.35,14.35,0,0,0,126.75,113.64ZM115.53,98.18a12.6,12.6,0,1,1,11.37,13.71A12.59,12.59,0,0,1,115.53,98.18Zm11.22,15.46a14.36,14.36,0,1,0-13-15.63A14.35,14.35,0,0,0,126.75,113.64ZM115.53,98.18a12.6,12.6,0,1,1,11.37,13.71A12.59,12.59,0,0,1,115.53,98.18Zm9.74,31.3A30.26,30.26,0,1,0,98,96.55,30.28,30.28,0,0,0,125.27,129.48ZM111.56,97.81a16.59,16.59,0,1,1,15,18A16.61,16.61,0,0,1,111.56,97.81Zm2.23.2a14.35,14.35,0,1,0,15.61-13A14.34,14.34,0,0,0,113.79,98Zm1.74.17a12.6,12.6,0,1,1,11.37,13.71A12.59,12.59,0,0,1,115.53,98.18Zm11.22,15.46a14.36,14.36,0,1,0-13-15.63A14.35,14.35,0,0,0,126.75,113.64ZM115.53,98.18a12.6,12.6,0,1,1,11.37,13.71A12.59,12.59,0,0,1,115.53,98.18Zm11.22,15.46a14.36,14.36,0,1,0-13-15.63A14.35,14.35,0,0,0,126.75,113.64ZM115.53,98.18a12.6,12.6,0,1,1,11.37,13.71A12.59,12.59,0,0,1,115.53,98.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.97 69.93 136.55 71 136.68 62.74 126.37 61.78 124.97 69.93",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.66 75.88 154.09 84.83 160.01 79.08 153.41 71.11 146.66 75.88",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.78 95.42 156.71 107.01 164.97 107.13 165.93 96.83 157.78 95.42",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.83 117.11 142.88 124.54 148.63 130.47 156.6 123.86 151.83 117.11",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.29 128.24 120.7 127.16 120.58 135.42 130.88 136.38 132.29 128.24",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.6 122.29 103.17 113.33 97.24 119.09 103.85 127.05 110.6 122.29",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.47 102.74 100.55 91.16 92.29 91.03 91.33 101.34 99.47 102.74",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.42 81.05 114.38 73.62 108.62 67.69 100.66 74.31 105.42 81.05",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.29,149.87a36.35,36.35,0,1,0,37.29-35.38A36.35,36.35,0,0,0,164.29,149.87Zm19.37.51a17,17,0,1,1,16.52,17.42A17,17,0,0,1,183.66,150.38Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.56 115.81 208.53 116.18 208.02 106.27 195.59 105.94 194.56 115.81",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.03 121.22 230.65 131.37 237.3 124 228.74 114.97 221.03 121.22",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.92 143.77 235.56 157.74 245.47 157.23 245.79 144.8 235.92 143.77",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.51 170.24 220.37 179.86 227.74 186.5 236.76 177.95 230.51 170.24",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.97 185.13 194 184.76 194.51 194.67 206.94 195 207.97 185.13",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.5 179.72 171.88 169.58 165.23 176.95 173.79 185.97 181.5 179.72",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.61 157.18 166.98 143.21 157.06 143.72 156.74 156.15 166.61 157.18",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.02 130.71 182.16 121.09 174.79 114.44 165.77 123 172.02 130.71",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.28,141.92l-11.91-3.53-9,8.56,2.9,12.07,11.91,3.54,9-8.55Zm-9.12,12.49a3.94,3.94,0,1,1,4.05-3.84A3.93,3.93,0,0,1,201.16,154.41Z",
    style: {
      fill: "#c7c7c7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cones--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.84,438.52l5.57-38.31,1.61.73,2.58,1.17,11.17,5.05,10,4.52,6.59,3,10,4.53,5.49,2.48a5.28,5.28,0,0,1-1.42,9.81l-2.32.32h0l-3.65.5-10.88,1.48-7.17,1-10.9,1.49-4.55.62Z",
    style: {
      fill: "#00D35C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.3,401.28a23.78,23.78,0,0,1-2.05,4.14c-3.4,5.29-5.86,16.15-4,28.65a16,16,0,0,0,.82,3.95l2.33-.15s10.86-23.83,46.36-17.2l-3.36-1.52-10-4.52-6.59-3-10-4.52Z",
    style: {
      opacity: 0.1,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.61 433.78 351.38 414.66 361.4 419.19 359.49 432.3 348.61 433.78",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.54 436.24 334.77 407.16 344.79 411.68 341.44 434.75 330.54 436.24",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.12,437.56H178.83l.47-1.64.76-2.62L183.32,422l2.93-10.17,1.92-6.7,2.93-10.17,1.6-5.58a5.09,5.09,0,0,1,9.56,0l.62,2.16h0l1,3.41,2.92,10.17,1.92,6.7L211.63,422l1.22,4.26Z",
    style: {
      fill: "#00D35C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "217.45 447.24 168.45 447.24 176.26 427.89 176.26 427.89 225.27 427.89 225.27 427.89 217.45 447.24 217.45 447.24",
    style: {
      fill: "#00D35C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.78 405.08 188.17 405.08 191.1 394.91 203.86 394.91 206.78 405.08",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.63 421.95 183.32 421.95 186.25 411.78 208.71 411.78 211.63 421.95",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.31,435a39.34,39.34,0,0,0,9.45,2.88,51,51,0,0,0,9.79.74c1.63-.11,3.28-.12,4.9-.37.82-.11,1.64-.16,2.45-.31s1.61-.3,2.43-.44c.4-.08.81-.14,1.21-.23l1.2-.3,2.41-.58c1.6-.43,3.17-1,4.8-1.39-1.51.71-3,1.43-4.58,2l-2.38.82-1.2.39c-.4.12-.81.21-1.22.32l-2.45.59c-.82.18-1.66.27-2.5.41a49.66,49.66,0,0,1-5,.46,40.42,40.42,0,0,1-10.05-1.08A27.42,27.42,0,0,1,178.31,435Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.59,435.61a23.36,23.36,0,0,1,4.23,1.38c5.52,2.5,16.2,3.34,27.87-.16a15.32,15.32,0,0,0,3.64-1.33l-.47-2.2s-24.22-7-22.82-41.8l-1,3.41-2.92,10.17-1.92,6.7L183.29,422Z",
    style: {
      opacity: 0.1,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.69 438.44 311.01 388.1 329.73 399.02 322.41 449.36 303.69 438.44 303.69 438.44",
    style: {
      fill: "#00D35C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.34,419.85c-1,9.31-4.42,16.56-7.52,16.21s-4.78-8.17-3.74-17.47,4.42-16.56,7.53-16.21S323.39,410.55,322.34,419.85Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.36,453.55c1.73.57,51.24.43,53.13-.77.71-.44,1.11-7.66,1.35-16.39.05-1.88.09-3.82.12-5.81,0-2.34.07-4.71.08-7,.06-10.34-.08-19.45-.08-19.45H357.73v26.46l.17,5.81s-18.93,8.54-20.86,10.08S333.63,453,335.36,453.55Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.36,453.55c1.73.57,51.24.43,53.13-.77.71-.44,1.11-7.66,1.35-16.39.05-1.88.09-3.82.12-5.81,0-2.34.07-4.71.08-7h-32.3v7l.17,5.81s-18.93,8.54-20.86,10.08S333.63,453,335.36,453.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.21,453.62c1.13.37,22.22.45,37.57.13,3.55-.07,6.8-.17,9.42-.29,3.62-.16,6-.36,6.43-.61.88-.56,1.29-11.15,1.49-22.32H357.73l.17,5.84s-19,8.58-21,10.12S333.48,453,335.21,453.62Z",
    style: {
      fill: "#00D35C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.92,451.63c8.34-.23,42-.37,50.29,0,.07,0,.07.05,0,.05-8.27.41-41.95.28-50.29,0C335.74,451.76,335.74,451.63,335.92,451.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.71,434.52c3.28-.62,7.3-.13,9.82,2.2.1.09,0,.23-.14.19a46.68,46.68,0,0,0-9.66-2A.21.21,0,0,1,356.71,434.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.35,436c3.28-.62,7.3-.13,9.81,2.21.1.09,0,.22-.14.19a46,46,0,0,0-9.66-2A.21.21,0,0,1,354.35,436Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352,437.39c3.28-.62,7.3-.13,9.82,2.2.09.09,0,.23-.14.2a46.15,46.15,0,0,0-9.67-2A.21.21,0,0,1,352,437.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.61,438.82c3.29-.62,7.3-.13,9.82,2.21.1.09,0,.22-.14.19a46,46,0,0,0-9.66-2A.21.21,0,0,1,349.61,438.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.71,266.78S392,352.93,391.79,354c0,.14-.09,1.8-.17,4.51-.47,14.83-1.26,75.74-1.26,75.74H354.82s1.95-69.44,3.28-82.22c1.7-16.3,12.39-85.27,12.39-85.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.55,357.06q1.65-28,4.95-55.87c1.25-10.47,2.75-20.9,4.24-31.34,0-.09.16-.08.14,0-2.75,18.57-4.7,37.29-6.37,56s-2.85,37.39-3.62,56.12c-.43,10.61-.76,33.93-1.1,44.55a.2.2,0,0,1-.39,0C385.9,407.58,386.44,376,387.55,357.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.69,428.48a27.7,27.7,0,0,1,2.89-.12c1.07,0,2.14-.05,3.2-.09q3.09-.12,6.18-.16,6.23-.11,12.45.09l3.42.12c1.22,0,2.44.15,3.66.15.09,0,.08.11,0,.11-2.09,0-4.2.18-6.29.25s-4.12.11-6.18.14c-4.14.06-8.3,0-12.45-.13l-3.42-.09-1.83-.08c-.54,0-1.08,0-1.62-.05A.07.07,0,1,1,356.69,428.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.71,266.78S392,352.93,391.79,354c0,.14-.09,1.8-.17,4.51l-16.76-91.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.21,453.77c1.79.38,51-5.21,52.73-6.6.65-.53.26-7.75-.47-16.44-.15-1.88-8-32.09-8-32.09l-33.17,3.54,9.43,32.05s-17.88,10.57-19.62,12.31S389.43,453.39,391.21,453.77Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.94,447.17c-1.74,1.39-50.94,7-52.73,6.6s-.82-5.5.92-7.23,19.62-12.31,19.62-12.31l-3.08-10.46,32.05-4.68c1.41,5.63,2.7,10.92,2.75,11.63C444.2,439.43,444.59,446.64,443.94,447.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.07,453.86c1.17.24,22.13-2,37.36-4,3.52-.46,6.74-.92,9.33-1.32,3.58-.56,6-1,6.33-1.31.65-.53.34-7.94-.62-16.49a33.53,33.53,0,0,0-1.32-5.86l-31.89,4.3,1.47,5s-18,10.62-19.74,12.37S389.29,453.47,391.07,453.86Z",
    style: {
      fill: "#00D35C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.56,451.8c8.27-1.15,41.73-5,50-5.49.07,0,.07,0,0,.05-8.17,1.32-41.66,4.88-50,5.57C391.4,452,391.38,451.82,391.56,451.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.35,432.5c3.19-1,7.24-.93,10,1.11.11.08,0,.23-.11.21a45.63,45.63,0,0,0-9.82-.9A.22.22,0,0,1,410.35,432.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.15,434.19c3.2-1,7.24-.93,10,1.11.11.08,0,.23-.12.21a46.16,46.16,0,0,0-9.82-.91A.21.21,0,0,1,408.15,434.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406,435.88c3.19-1,7.24-.93,10,1.11.1.08,0,.23-.12.21a46.28,46.28,0,0,0-9.82-.91A.21.21,0,0,1,406,435.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.76,437.56c3.2-1,7.24-.93,10,1.11.11.08,0,.23-.11.21a45.66,45.66,0,0,0-9.83-.9A.22.22,0,0,1,403.76,437.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.06,266.3s1.55,9.25,6.59,15.57c1.2,1.51,4.9,2.93,6.81,4.32,0,0,6.34,67.7,7.2,77.67,1.19,13.67,17,69.79,17,69.79l36.65-6.28S429,370,425.85,356.83c-.72-3-6.42-65.43-6.24-66.76,2.14-15.92-5.46-25.81-5.46-25.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.27,267.74a11.77,11.77,0,0,0,4.35,6.24,14.71,14.71,0,0,0,7.89,2.71c.48,0,.52.76,0,.76-5.8,0-11.65-3.67-12.5-9.67C399,267.64,399.23,267.61,399.27,267.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376,281.61a32.3,32.3,0,0,1,6,3.17c2,1.23,3.83,2.68,5.75,4,.07,0,0,.17-.07.12-2-1.16-4.11-2.16-6.1-3.36a37.16,37.16,0,0,1-5.65-3.79C375.8,281.71,375.87,281.58,376,281.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.14,269.53c.31,1.32.7,2.64,1.05,4s.58,2.5,1,3.72a6.35,6.35,0,0,0,1.89,3.07c.51.43,1.07.81,1.61,1.21.29.21.61.41.91.62-.05-.17-.09-.35-.13-.53l-.33-1.51q-.36-1.68-.69-3.36c-.44-2.21-.86-4.44-1.42-6.62a.07.07,0,1,1,.13,0c.66,2.15,1.37,4.28,1.95,6.46.28,1.07,1.37,6.35,1.43,6.72s.1.78.13,1.17a4.76,4.76,0,0,1,.06,1.19.1.1,0,0,1-.18,0h0a5,5,0,0,1-.39-1.14c-.11-.37-.22-.76-.3-1.14,0-.14-.06-.28-.08-.42-.54-.3-1.05-.69-1.56-1s-1.1-.7-1.62-1.1a6,6,0,0,1-2-2.9,21.22,21.22,0,0,1-.8-3.8c-.24-1.5-.44-3-.72-4.51C375,269.48,375.12,269.44,375.14,269.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.23,426.76c.89-.3,10-2.24,12-2.66,4.06-.85,18.05-3.08,19.25-3.31.09,0,.11.09,0,.11-2.05.38-8.1,1.81-12.17,2.72s-18.51,3.25-19.05,3.28C409.16,426.91,409.14,426.79,409.23,426.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.51,387.87c-2.58-10-5.39-20-7.19-30.2-.9-5.12-1.41-10.29-1.82-15.47s-.82-10.4-1.22-15.6S416.46,316.18,416,311s-.89-10.53-.93-15.81c-.08-8.57,1.48-17.87-2.2-25.94a20.76,20.76,0,0,0-1.47-2.65.16.16,0,0,0-.27.17c4.53,7.83,3.35,17.27,3.18,25.92-.11,5.12.24,10.22.63,15.32s.81,10.43,1.22,15.64.83,10.42,1.24,15.63.78,10.26,1.49,15.36c1.38,10.07,4.14,19.91,6.69,29.74,2.63,10.11,5.23,20.25,8.15,30.27.37,1.26.72,2.52,1.07,3.77a.09.09,0,0,0,.17-.05Q431.41,403.07,427.51,387.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376,181.76c2.7-2.91,7.25-3.53,11.64-2.58s9.61,3.19,10,10.22c.3,5.71-1.65,11.23-1.73,17.6s7.17,22-5,29.32c-10.95,6.55-32.81-.18-33.25-14.19-.35-11.1,13.59-21,15.12-25.39S373,185,376,181.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.91,188a23.7,23.7,0,0,1-2.1,9.34,9,9,0,0,1-1.4,2.07c-.55.63-1.12,1.22-1.7,1.81-1.16,1.16-2.31,2.31-3.39,3.51a32,32,0,0,0-5.44,7.86,24,24,0,0,0-2.27,9.13,20.64,20.64,0,0,1,.23-4.77,23,23,0,0,1,1.36-4.63,28.64,28.64,0,0,1,5.38-8.15c1.11-1.22,2.29-2.38,3.46-3.53a16.2,16.2,0,0,0,3.1-3.62,19.81,19.81,0,0,0,1.74-4.38A36.2,36.2,0,0,0,373.91,188Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.23,194.19c-.14,3.23-.41,6.46-.37,9.67a36.37,36.37,0,0,0,.34,4.79c.22,1.57.68,3.14,1.06,4.72s.72,3.2,1,4.82a26,26,0,0,1,.25,4.91,16.56,16.56,0,0,1-1,4.81,12,12,0,0,1-2.89,4,12.4,12.4,0,0,0,2.45-4.18,16.24,16.24,0,0,0,.74-4.69,39.68,39.68,0,0,0-1.4-9.51c-.36-1.59-.82-3.16-1-4.82a30.81,30.81,0,0,1-.18-4.89A74.19,74.19,0,0,1,397.23,194.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,215.54c-1.32,5.4-17,56-20.1,56.68-9.14,2.06-20.12,3.57-20-3.93.25-11.77,22.37-42.74,33-53C386.85,208.47,388.25,210.21,387,215.54Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,229.57l16.28,3.88s4.67-15.79,5.43-19.87-2.44-4-7.36.79S366,229.57,366,229.57Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.54,227.71c-.11,0-.16,0-.05.08a117.4,117.4,0,0,0,14.43,2.88s0,0,0-.06C380.63,229.84,369.78,228,368.54,227.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.46,248.79l-3,25s40.52-.36,50.56-1.31c0,0-9.3-46.27-20.39-57.76-5.55-5.74-11.89-5.15-15.84-.95-1,1.06-12.83,17.5-14,23.7C367.8,242.89,371.46,248.79,371.46,248.79Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.43,273.73l3-24.94s-3.66-5.9-2.67-11.37c1.14-6.2,13-22.64,14-23.7a10.27,10.27,0,0,1,1.19-1.1l-5.18,14.93,15.39-16.11a12.7,12.7,0,0,1,4.43,3.24C409.69,226.16,419,272.43,419,272.43,409,273.38,368.43,273.73,368.43,273.73Z",
    style: {
      fill: "#00D35C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.89,258.93l-45.84,1.41.48-4L414.9,255C415.25,256.36,415.58,257.67,415.89,258.93Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.55,265.83l-48.35,1.49.49-4,46.93-1.44C417,263.33,417.28,264.65,417.55,265.83Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.09,213c-.24.78-4.38,5.68-8,5.27-1.18-.14-.72-6.61-.72-6.61l-.07-.49-1-6.79,8.2-4.51,1.18-.59s.16,1.88.34,4.22q0,.15,0,.33c0,.13,0,.26,0,.38,0,.35.07.71.09,1.06s0,.54.05.82,0,.56,0,.85A43.83,43.83,0,0,1,392.09,213Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392,203.52a13.75,13.75,0,0,1-8.68,7.67l-1-6.79,8.2-4.51,1.18-.59S391.8,201.18,392,203.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.71,193c-2.23,11.86,4.62,14.53,7.18,15,2.32.43,10.28,1.61,13.72-10s-1.37-16.35-6.63-17.62S374.93,181.16,372.71,193Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.86,190.06a5.78,5.78,0,0,0,.83.05,1.33,1.33,0,0,0,.86-.12.43.43,0,0,0,.14-.5,1.06,1.06,0,0,0-.95-.51,1.5,1.5,0,0,0-1.09.28A.45.45,0,0,0,375.86,190.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384,191.79c-.27-.08-.51-.2-.77-.3a1.34,1.34,0,0,1-.73-.46.42.42,0,0,1,.08-.52,1.07,1.07,0,0,1,1.08-.07,1.56,1.56,0,0,1,.87.7A.46.46,0,0,1,384,191.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.66,194.53s.06.05,0,.08c-.18.8-.25,1.75.43,2.16,0,0,0,0,0,0C381.26,196.52,381.36,195.26,381.66,194.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.54,193.82c1.32.15.93,2.77-.29,2.64S381.44,193.7,382.54,193.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383,194c.2.18.39.48.66.55s.6-.16.85-.39c0,0,0,0,0,0-.07.51-.34,1-.89,1s-.79-.51-.84-1C382.85,194.09,383,194,383,194Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,193.63s-.07,0-.07.07c-.09.81-.33,1.73-1.11,1.9,0,0,0,.05,0,.05C376.73,195.65,377,194.42,377,193.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.39,192.68c-1.3-.28-1.77,2.33-.57,2.59S377.47,192.92,376.39,192.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.81,192.75c-.23.1-.48.32-.73.29s-.45-.35-.58-.66c0,0,0,0-.05,0-.1.5,0,1,.43,1.23s.82-.2,1-.68C376,192.87,375.9,192.71,375.81,192.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.66,201.14c-.19.2-.38.47-.67.51a2.24,2.24,0,0,1-.89-.17s-.06,0,0,0a1.08,1.08,0,0,0,1.06.4.87.87,0,0,0,.62-.75S380.69,201.11,380.66,201.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.5,197.52s-.36,1.18-.46,1.76c0,.05.13.1.32.14,0,0,0,0,0,0a2.75,2.75,0,0,0,2.8-.58c.05-.05,0-.12-.07-.1a4.14,4.14,0,0,1-2.59.31c0-.16.69-2,.6-2a5.34,5.34,0,0,0-1.35.09c.69-2.49,1.77-4.85,2.41-7.34,0-.08-.1-.13-.14-.06a41.21,41.21,0,0,0-2.93,7.79C376,197.82,377.25,197.58,377.5,197.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.46,199.34a3.4,3.4,0,0,0,1.14,1.27,1.5,1.5,0,0,0,.89.22c.69-.05.82-.65.79-1.18a3.6,3.6,0,0,0-.15-.84A4.42,4.42,0,0,1,377.46,199.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.6,200.61a1.5,1.5,0,0,0,.89.22c.69-.05.82-.65.79-1.18A1.56,1.56,0,0,0,378.6,200.61Z",
    style: {
      fill: "#ff9bbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.55,198.62s3-3.48,4.6-2.38-.9,6.34-3,6.88a2,2,0,0,1-2.61-1.36Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.4,197.72s0,.05,0,.06a5.18,5.18,0,0,0-3,2.94,1.14,1.14,0,0,1,1.71-.14s0,.09-.05.08a1.24,1.24,0,0,0-1.41.29,6,6,0,0,0-.77,1.05c-.08.12-.3,0-.24-.11l0,0C391.83,200.07,393.46,197.71,395.4,197.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.15,197.64c-1.28-.27-4.13-4.3-3.35-10.56,0,0-.32,5.67,0,6.55s-1.6-2.27-1-7.32a20.78,20.78,0,0,1-5.55,1.94c-2.47.32-3.92.09-4.06-.1s3.5-.8,4.61-1.75c0,0-6.74,2-9.69,1.84-.34,0,.25-7,5.17-9.31s11.61,1.9,13.26,4c0,0,2.21.65,4.18,4.33S394.53,197.92,393.15,197.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.93,185.1s4.37-12.93,15.93-9.13,7.4,16.81,7.4,16.81Z",
    style: {
      fill: "#00D35C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.41,
    y: 187.97,
    width: 26.39,
    height: 1.93,
    transform: "translate(78.37 -111.06) rotate(18.21)",
    style: {
      fill: "#00D35C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "385.71 187.96 380.5 186.24 385.91 173.93 391.13 175.65 385.71 187.96",
    style: {
      fill: "#00D35C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "385.71 187.96 380.5 186.24 385.91 173.93 391.13 175.65 385.71 187.96",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.38,205.65h10.35a7.43,7.43,0,0,1,7.43,7.43v65.69a0,0,0,0,1,0,0H352a0,0,0,0,1,0,0V213.07A7.43,7.43,0,0,1,359.38,205.65Z",
    transform: "translate(-64.6 156.27) rotate(-22.28)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.2,
    y: 275.78,
    width: 16.99,
    height: 6.74,
    transform: "translate(-77.48 164.76) rotate(-22.28)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.03,
    y: 279.57,
    width: 5.39,
    height: 72.54,
    transform: "translate(-90.26 173.2) rotate(-22.28)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.92,353.24s1.17,11.58.84,11.71l-1.66.68h0l-1.65.68c-.33.13-7.62-8.94-7.62-8.94l.17-6.94,5-2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.4,
    y: 218.08,
    width: 4.4,
    height: 56.51,
    transform: "translate(-66.69 153.94) rotate(-22.28)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.97,
    y: 214.98,
    width: 4.4,
    height: 56.51,
    transform: "translate(-64.95 156.58) rotate(-22.28)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.53,
    y: 211.88,
    width: 4.4,
    height: 56.51,
    transform: "translate(-63.22 159.23) rotate(-22.28)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.13,243.73a3.11,3.11,0,0,1,.58,3.48,4.55,4.55,0,0,1,2.65,1.62c1.11,1.53-.8,3.94-.8,3.94a5.65,5.65,0,0,1,2.53,2.16c.91,1.57-.68,4.27-.68,4.27a4.93,4.93,0,0,1,1,3.3c-.31,3.17-4.65,5.34-7.4,6.74s-11.87,2.82-13.58,3.27l-9.18-17.57s10.54-9.81,14-11C373.21,242.93,379.38,242.07,381.13,243.73Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.53,253.8c-3.15,2.41-12.58,11.72-10.37,16.46s9.81,4.25,20.34,1.83Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.44,247c-3.36.32-6.45,1.62-9.6,2.75-.07,0,0,.13,0,.11,3.12-1.16,6.43-1.68,9.59-2.71A.08.08,0,0,0,381.44,247Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.38,252.57a8.48,8.48,0,0,0-2.18.73c-.76.31-1.5.64-2.25,1-1.48.68-3,1.39-4.41,2.14-.06,0,0,.14,0,.11,1.49-.67,3-1.32,4.49-1.93l2.28-.89a11,11,0,0,0,2.11-.92A.12.12,0,0,0,383.38,252.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.35,259.23a6.27,6.27,0,0,0-1.93.76l-2,1c-1.35.62-2.7,1.25-4.07,1.83-.07,0,0,.14,0,.11,1.4-.58,2.8-1.15,4.19-1.74l2-.89a5.76,5.76,0,0,0,1.79-1S385.38,259.23,385.35,259.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.12,254a29,29,0,0,0-3.13,2.66l-.74.76-.32.21c-.44.29-.88.6-1.3.93a25.32,25.32,0,0,0-2.28,2.11c-.05.06,0,.14.08.08a21.79,21.79,0,0,1,2.43-2l.34-.23c-.41.46-.81.92-1.18,1.41a39.34,39.34,0,0,0-2.75,4,.06.06,0,0,0,.1.06c1.53-2.46,8.22-9.05,8.95-9.84S357.67,253.51,357.12,254Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.51,215.18c11.38,10.46,21.08,30.74,21.1,35.73,0,6.31-10.23,36.61-15.38,42-2,2.07-19.6-12.55-17.46-14.75,3.64-3.73,13.79-28,13.88-29.73.07-1.07-5.13-17.66-8.55-26.84C389.39,209,397.06,212,400.51,215.18Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.17,303.8a5.36,5.36,0,0,0,3.5,1.05,5.3,5.3,0,0,0,1.17,3.4c1.44,1.63,4.62.08,4.62.08a6.53,6.53,0,0,0,1.8,3.39c1.54,1.42,5,.31,5,.31a5.73,5.73,0,0,0,3.45,2c3.64.45,7.18-3.91,9.45-6.65s6.16-12.66,7.09-14.47l-17.46-14.75s-13.69,9.41-15.9,13C371,294.2,367.83,302,370.17,303.8Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.64,304.76A47.78,47.78,0,0,1,379,294.37c.05-.07.16,0,.11.07-2.08,3.23-3.35,7.09-5.3,10.39A.09.09,0,0,1,373.64,304.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.28,308.08a10.05,10.05,0,0,1,1.38-2.28c.54-.77,1.09-1.53,1.66-2.28q1.69-2.26,3.51-4.44c.05-.06.16,0,.11.08q-1.69,2.25-3.29,4.57c-.54.78-1.06,1.56-1.58,2.34a11.85,11.85,0,0,1-1.57,2.15A.14.14,0,0,1,379.28,308.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.28,312a7,7,0,0,1,1.35-2l1.58-2c1-1.36,2.09-2.73,3.09-4.13.05-.07.16,0,.11.08-1,1.42-2,2.86-3,4.28-.5.7-1,1.39-1.52,2.08a6.48,6.48,0,0,1-1.53,1.76A0,0,0,0,1,386.28,312Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.72,236.2l16-7.12S406,217.89,399.25,213.9s-7.66-.28-6.3,5.31S398.72,236.2,398.72,236.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.75,233c-.1.05-.11.14,0,.1a120.08,120.08,0,0,0,13.42-6s0-.06,0,0C409.83,227.7,399.92,232.49,398.75,233Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.11,223.54c1.42,4.29,3,8.75,4.55,12.9,0,.07.66-.35.93-.5.1-.06,0-.15-.1-.1a3.11,3.11,0,0,1-.61.2c-1.53-4.19-3.06-8.38-4.72-12.52C394.15,223.49,394.1,223.51,394.11,223.54Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.27,398.78c-1.79.56-52.38-.53-54.28-1.79-.72-.47-1-7.85-1.07-16.77,0-1.93,0-3.91,0-5.94,0-2.4,0-4.82,0-7.17.14-10.57.46-19.87.46-19.87l32.93.61L130,367.72l-.14,7.17-.28,5.93s19.18,9.08,21.12,10.69S154,398.23,152.27,398.78Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.27,398.78c-1.79.56-52.38-.53-54.28-1.79-.72-.47-1-7.85-1.07-16.77,0-1.93,0-3.91,0-5.94,0-2.4,0-4.82,0-7.17l33,.61-.14,7.17-.28,5.93s19.18,9.08,21.12,10.69S154,398.23,152.27,398.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.42,398.86c-1.16.36-22.71,0-38.4-.58-3.63-.15-7-.31-9.62-.47-3.69-.24-6.17-.49-6.56-.75-.88-.59-1.11-11.42-1.1-22.84l33.1.61-.28,6s19.29,9.13,21.24,10.74S154.2,398.3,152.42,398.86Z",
    style: {
      fill: "#00D35C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.73,396.81c-8.52-.39-42.94-1.17-51.39-.91-.07,0-.07.05,0,.05,8.44.58,42.86,1.07,51.39,1C151.91,397,151.91,396.82,151.73,396.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.81,378.93c-3.35-.7-7.46-.27-10.08,2.06-.1.09,0,.24.14.2a47.58,47.58,0,0,1,9.91-1.84A.21.21,0,0,0,130.81,378.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.2,380.44c-3.35-.7-7.46-.27-10.08,2.07-.1.09,0,.23.14.2a47.07,47.07,0,0,1,9.91-1.85A.21.21,0,0,0,133.2,380.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.59,382c-3.34-.7-7.46-.27-10.07,2.07-.11.09,0,.23.13.2a47,47,0,0,1,9.92-1.84A.22.22,0,0,0,135.59,382Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,383.46c-3.34-.7-7.46-.27-10.07,2.07-.11.09,0,.23.13.2a47,47,0,0,1,9.92-1.84A.22.22,0,0,0,138,383.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.17,371.3c-1.28-1.84-3.75-1.08-5.18.07a17.88,17.88,0,0,0-5.33,7.57.09.09,0,0,0,.07.13c0,.25.23.53.52.43,2.8-1,5.9-1.66,8.31-3.45C137,375,138.38,373.05,137.17,371.3Zm-6,5.87c-1.37.5-2.74.94-4.09,1.5,1.05-1.47,2-3,3.21-4.35a19.14,19.14,0,0,1,1.82-1.89c1-.88,5-2.73,4.35.94C136.11,375.39,132.81,376.56,131.19,377.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.15,377.89c2.74,1.23,5.92,1.24,8.85,1.59a.42.42,0,0,0,.42-.53.1.1,0,0,0,0-.14,18,18,0,0,0-6.83-6.26c-1.64-.82-4.22-1-5.08,1S116.55,377.16,118.15,377.89Zm-1.47-2.43c-1.43-3.44,2.86-2.49,4-1.84a21.14,21.14,0,0,1,2.18,1.45,52.88,52.88,0,0,1,4.06,3.57c-1.43-.26-2.87-.39-4.31-.6C121,377.8,117.48,377.36,116.68,375.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.52,398.68c-4.25-.11-8.56-.25-12.5-.41-3.63-.13-7-.29-9.62-.46-3.69-.24-6.17-.49-6.56-.76-.77-.51-1-8.88-1.09-18.62C104.26,383.45,119,393.54,126.52,398.68Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.79,380.41l-37.59,0s2.06-84.61,1.66-86.58c-1-4.71-22.34-79.3-22.34-79.3l29.68.51,10.13.17s-.87,12.43-.52,13.74c5,18.1,14.65,49,16.62,60.46C133.86,309.3,132.79,380.41,132.79,380.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.57,374.13c-5.86-.15-26.63-.77-34.45-.19a.06.06,0,0,0,0,.12c2.68.43,28.59.31,34.45.23A.08.08,0,1,0,131.57,374.13Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.81,292c-1.12-4.57-9.49-33.07-12.06-42.07s-5-18-7.17-27.12c-.28-1.15-.56-2.3-.87-3.45,0-.1-.16-.05-.15,0,.85,4.58,2,9.11,3,13.64s2.22,9,3.43,13.54q3.64,13.54,7.94,26.91c1.43,4.44,3.8,13.55,5.06,18s-.8,78.17-.67,79.36a.27.27,0,0,0,.54,0C99.06,362.2,100.92,296.52,99.81,292Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.2,215.07s-7.26,79.18-7.34,78.79c-.93-4.55-21-74.7-22.29-79.08l-.06-.21Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.28,403.12c-1.78.55-52.37-.53-54.27-1.79-.72-.47-1-7.86-1.07-16.78,0-1.93,0-3.91,0-5.94,0-2.39,0-4.81,0-7.17.13-10.56.45-19.87.45-19.87l32.94.61L91,372.05l-.14,7.17-.28,5.94s19.18,9.08,21.12,10.69S115.06,402.57,113.28,403.12Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.28,403.12c-1.78.55-52.37-.53-54.27-1.79-.72-.47-1-7.86-1.07-16.78,0-1.93,0-3.91,0-5.94,0-2.39,0-4.81,0-7.17l33,.61-.14,7.17-.28,5.94s19.18,9.08,21.12,10.69S115.06,402.57,113.28,403.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.44,403.19c-1.17.36-22.72,0-38.4-.57-3.63-.15-7-.31-9.63-.48-3.68-.24-6.16-.48-6.56-.75-.88-.58-1.1-11.41-1.09-22.84l33.1.62-.28,6s19.29,9.13,21.24,10.75S115.22,402.63,113.44,403.19Z",
    style: {
      fill: "#00D35C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.75,401.14c-8.52-.39-42.94-1.16-51.39-.9-.07,0-.07,0,0,.05,8.44.57,42.86,1.07,51.4,1C112.93,401.28,112.93,401.15,112.75,401.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.82,383.26c-3.34-.69-7.45-.27-10.07,2.07-.1.09,0,.23.14.2a46.93,46.93,0,0,1,9.91-1.84A.22.22,0,0,0,91.82,383.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.21,384.78c-3.34-.7-7.45-.27-10.07,2.06-.1.09,0,.23.14.2a47.58,47.58,0,0,1,9.91-1.84A.21.21,0,0,0,94.21,384.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.61,386.29c-3.35-.7-7.46-.27-10.08,2.06-.1.09,0,.24.14.2a47.58,47.58,0,0,1,9.91-1.84A.21.21,0,0,0,96.61,386.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,387.8c-3.35-.7-7.46-.27-10.08,2.06-.1.1,0,.24.14.21A47,47,0,0,1,99,388.22.21.21,0,0,0,99,387.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.19,375.64c-1.28-1.85-3.76-1.08-5.18.06a17.91,17.91,0,0,0-5.33,7.58.08.08,0,0,0,.07.12c0,.26.23.53.52.43,2.79-1,5.9-1.65,8.31-3.45C98,379.34,99.4,377.38,98.19,375.64Zm-6,5.86c-1.36.51-2.74.95-4.08,1.51a52.57,52.57,0,0,1,3.21-4.36,20.2,20.2,0,0,1,1.82-1.88c1-.89,5-2.74,4.34.93C97.12,379.72,93.83,380.89,92.2,381.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.17,382.22c2.74,1.24,5.92,1.25,8.85,1.6a.42.42,0,0,0,.42-.54.08.08,0,0,0,0-.13,17.86,17.86,0,0,0-6.82-6.26c-1.64-.82-4.22-1-5.08,1S77.57,381.5,79.17,382.22ZM77.7,379.8c-1.44-3.45,2.86-2.49,4-1.84a17.55,17.55,0,0,1,2.18,1.45A51.19,51.19,0,0,1,88,383c-1.43-.26-2.87-.4-4.31-.6C82,382.13,78.49,381.69,77.7,379.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.77,384.24l-36.47-.67s10.24-131.55,9-138.52c-2.09-11.41-.31-24.43,5.18-30.61l35.54.66s.52,10-3.26,15.87c0,0-3.37,2.05-5,2.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.77,377.77c-5.53-.25-3.94-.26-9.48-.44-2.7-.09-20.5-.67-23-.31,0,0,0,.1,0,.11,2.52.48,20.32.75,23,.78,5.54.08,4,0,9.48,0C91.87,377.93,91.87,377.77,91.77,377.77Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,229.42a68.37,68.37,0,0,0-10.1,5.73.12.12,0,0,0,.12.2c3.42-1.81,6.91-3.56,10.21-5.54A.23.23,0,1,0,105,229.42Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.46,228.82a15.2,15.2,0,0,0-.52,2.09,4.41,4.41,0,0,0-.14,1.69.12.12,0,0,0,.22,0,5.85,5.85,0,0,0,.59-1.69c.18-.65.37-1.29.54-1.95A.36.36,0,0,0,100.46,228.82Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.2,225.39c.11-.59.21-1.18.33-1.77s.29-1.22.36-1.84c0-.1.17-.06.15,0-.1.59-.12,1.2-.18,1.8s-.13,1.2-.2,1.8a32.19,32.19,0,0,1-.59,3.35,4,4,0,0,0,1.65-.65,3.22,3.22,0,0,0,.91-1.7c.18-.67.34-1.36.54-2a12.65,12.65,0,0,0,.56-2.26c0-.1.17-.07.15,0a23.66,23.66,0,0,1-1,4.77,2.6,2.6,0,0,1-.92,1.57,5.15,5.15,0,0,1-2,.55c-.08,0-.2,0-.19-.1A35.61,35.61,0,0,1,100.2,225.39Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.05,244.7c-.21-2.61-.59-5.21-.82-7.83a48.34,48.34,0,0,1,1.23-15.62.07.07,0,1,0-.14,0,57.58,57.58,0,0,0-1.66,13.7c.14,4.61.88,9.17.87,13.79s-.47,9.34-.86,14-.77,9.37-1.16,14.06c-1.56,18.83-3,37.67-4.53,56.51-.42,5.26-.81,10.52-1.21,15.78s-1,18.55-1.33,23.91c0,.47.67.44.71,0,1-9.45,1.76-26.79,2.54-36.25s1.5-18.74,2.24-28.12,1.49-18.74,2.22-28.11q.54-7,1.07-14.06c.36-4.66.79-9.33,1-14A70.84,70.84,0,0,0,71.05,244.7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.07,221.16c0-.06-.1-.08-.14,0a6,6,0,0,0-.37,1.91,13.13,13.13,0,0,1-.53,2,8.15,8.15,0,0,1-2.19,3.55c-2.28,2-5.29,2.77-8.19,3.43-.11,0-.07.17,0,.18a12.94,12.94,0,0,0,5-.7,10.46,10.46,0,0,0,3.93-2.1,7.25,7.25,0,0,0,2.17-3.76,12.79,12.79,0,0,0,.28-2.3c0-.37,0-.74,0-1.11A2.83,2.83,0,0,0,84.07,221.16Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.07,166c5.35,17.2,16.15,33.94,19.5,36.22,5.18,3.53,29.76,6.56,37.84,5.61,2.65-.31,1.67-18.67-.75-20.17s-26.32-1.8-27.94-2.44c-.86-.34-13.6-15-20.77-22.71C106.27,155.31,103.45,160.73,105.07,166Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.8,173.48l-13.65,11s-6-12.9-6.44-20.72,3.24-6.94,7.59-3.18S123.8,173.48,123.8,173.48Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.37,171.9c.09-.07.07-.15,0-.09A118.48,118.48,0,0,0,109.89,181a0,0,0,0,0,0,.05C112,179.82,120.37,172.67,121.37,171.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.62,218.54c.09.16,51.69,10.54,52.26,10.1.81-.61,1.76-54-4.42-66.85-1.55-3.2-8.54-6.47-12.12-4.15C90,164.35,86.85,171,83.5,176.3a171.51,171.51,0,0,0-9.06,17.83C69.14,205.77,64.29,218,64.62,218.54Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.44,157.6s4.51,18.77,5,23.44c.63,6.38-4,46.92-4,46.92l-36.67-8.8S78,180.34,88.54,167.56C96.87,157.5,99.44,157.6,99.44,157.6Z",
    style: {
      fill: "#00D35C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.3,160.59s1.46,16.66,1.88,19.19-.42,50.43-.42,50.43l4.87-.88s.64-33.15-1-50.37S111.3,160.59,111.3,160.59Z",
    style: {
      fill: "#00D35C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.09,212.09l-33.14-6c.5-1.2,1-2.45,1.58-3.74l32,5.79C102.36,209.47,102.22,210.8,102.09,212.09Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.76,214.92l-4.74-.85c0-1.31,0-2.66,0-4l4.68.85C117.76,212.28,117.76,213.63,117.76,214.92Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.36,219l-35.11-6.37,1.53-3.74,34,6.17C101.63,216.47,101.48,217.79,101.36,219Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.73,222l-4.82-.87c0-1.25,0-2.6.07-4l4.77.86C117.74,219.42,117.73,220.76,117.73,222Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,143a24.82,24.82,0,0,1,25.63-5.24l-14.79,14,4.74,10.74L199,167.78l14.8-14A24.85,24.85,0,1,1,173,143Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.29,277.13a24.85,24.85,0,0,1-25.63,5.25l14.79-14-4.74-10.74-10.45-5.35-14.8,14a24.85,24.85,0,1,1,40.83,10.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.15,
    y: 147.68,
    width: 22.13,
    height: 120.84,
    transform: "translate(85.13 452.92) rotate(-133.35)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.66,
    y: 183.22,
    width: 9.11,
    height: 49.76,
    transform: "translate(85.13 452.91) rotate(-133.35)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,169c-5.17,13.19-5.84,32.86-1,38.56,7.62,9,21.4,17.05,28.15,19.08,3.94,1.19,10-21.29,6.59-22.52-5.44-1.94-18.34-7.2-20.09-8.39s-3.06-15.1-4.81-25.34C98,159.21,93.64,162.23,91,169Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.43,225.93c11.66,4.78,25.54,3.08,27.81,2.28,1.94-.67,2.94-1,2.94-1,3.5-1.14,4.37-3.14,4.37-3.14s4.44-.12,4.81-2.82c.42-3-5.89-2.25-9.63-4-8.54-3.9-19.61-11.83-22-13.19Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.91,219.47a60.58,60.58,0,0,0,7.67,3,59.82,59.82,0,0,0,8.91,1.49.08.08,0,0,1,0,.15,32,32,0,0,1-16.68-4.41C134.69,219.62,134.78,219.42,134.91,219.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.81,224.29a44.3,44.3,0,0,0,15.37,2.79,0,0,0,0,1,0,.06,28.82,28.82,0,0,1-15.46-2.59C131.57,224.48,131.64,224.23,131.81,224.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.73,211.91c-.91-.95-.42-1.43,1.9-1.11s11.21,3.57,12.08.37-11.75-7.59-15.65-7.84a61.86,61.86,0,0,0-10.29.74C127.06,205.41,132.28,209.21,136.73,211.91Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.84,185.21,85.36,186.6s2.35-14,6.37-20.74,6.59-3.9,8.06,1.66S102.84,185.21,102.84,185.21Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.72,182.54c.12,0,.15-.09,0-.09a117.66,117.66,0,0,0-14.67,1.16s0,.06,0,.06C89.52,183.78,100.46,182.6,101.72,182.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.26,166.48c-2.22,0-6.71-4.25-8.4-7.8-.12-.24.39-2.71.85-5.74.28-1.84.54-3.89.65-5.78l11.7,3.54a30,30,0,0,0-1.55,7.2,3.92,3.92,0,0,0,0,.78s0,.08,0,.13C111.71,160.3,111.73,166.43,108.26,166.48Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.54,158.68a.93.93,0,0,0,0,.14,10.18,10.18,0,0,1-1.23,0c-6.87-.54-8.1-9.09-8.31-11.44l11,3.33a30,30,0,0,0-1.55,7.2A4.89,4.89,0,0,0,111.54,158.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,131.12c-2,3.92-2,16.29.52,19.49,3.58,4.63,10.51,6.25,14.72,1.7s3.73-20.53.87-23.55C113.94,124.32,105,125.33,102,131.12Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.17,140.25s-.06,0-.06.07c.06.83,0,1.8-.75,2.11,0,0,0,0,0,0C113.29,142.3,113.36,141,113.17,140.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.39,139.41c-1.34,0-1.33,2.64-.09,2.69S113.52,139.45,112.39,139.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.61,140.08s.06,0,.06.08c0,.83.09,1.79.84,2.06,0,0,0,.05,0,.05C117.59,142.14,117.45,140.87,117.61,140.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.35,139.21c1.34-.11,1.45,2.58.21,2.68S117.22,139.3,118.35,139.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.33,138.18a10.78,10.78,0,0,0,1-.37,1.77,1.77,0,0,0,1-.58.59.59,0,0,0-.1-.69,1.44,1.44,0,0,0-1.42-.14,2.07,2.07,0,0,0-1.19.9A.61.61,0,0,0,111.33,138.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.28,138.16c-.37-.06-.71-.18-1.07-.27a1.81,1.81,0,0,1-1-.49.56.56,0,0,1,0-.69,1.37,1.37,0,0,1,1.4-.27,2.08,2.08,0,0,1,1.27.78A.61.61,0,0,1,119.28,138.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.94,148c.2.19.4.46.7.49a2.13,2.13,0,0,0,.89-.22s.06,0,0,0a1.1,1.1,0,0,1-1.06.46.88.88,0,0,1-.65-.73C111.84,148,111.91,148,111.94,148Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.8,145.51a2.85,2.85,0,0,0,1.9,1.26,3.86,3.86,0,0,0,1,0l.2,0,.18,0a.22.22,0,0,0,.17-.19h0s0-.05,0-.08h0v-.07c0-.64-.05-1.62-.05-1.62.23.12,1.43.65,1.41.32a42.24,42.24,0,0,0-1.14-8.58.08.08,0,0,0-.15,0c.07,2.67.6,5.31.71,8a4.8,4.8,0,0,0-1.34-.4c-.1,0,.16,1.88.13,2.17v0a3.94,3.94,0,0,1-2.94-.9C112.82,145.39,112.75,145.44,112.8,145.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.34,146.49a3.25,3.25,0,0,1-1.34,1,1.52,1.52,0,0,1-.92.07c-.67-.18-.69-.79-.57-1.31a3.63,3.63,0,0,1,.3-.8A4.4,4.4,0,0,0,115.34,146.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,147.53a1.52,1.52,0,0,1-.92.07c-.67-.18-.69-.79-.57-1.31A1.56,1.56,0,0,1,114,147.53Z",
    style: {
      fill: "#ff9bbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.6,132.16c-.12-.37-.45-1.3-.93-1.35s-1.08.88-2.23,1.09c-1.62.31-4.25-1.68-6.49-1.27s-3.72,2.36-4.48,6.22-4.1,6.71-4.75,4.08a5,5,0,0,0-.11-.5c0-3.76.48-7.47,1.43-9.31,3-5.79,11.9-6.8,16.11-2.35A7.71,7.71,0,0,1,119.6,132.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.86,141.34s-2.11-4.32-4-3.63-.77,6.65,1.18,7.75a2.13,2.13,0,0,0,3-.69Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.21,139.41s0,0,0,.06a5.34,5.34,0,0,1,2.22,3.76,1.18,1.18,0,0,0-1.69-.59s0,.08,0,.08a1.32,1.32,0,0,1,1.36.68,6.89,6.89,0,0,1,.5,1.26c0,.14.29.11.26,0v0C102.2,142.73,101.17,139.91,99.21,139.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,133.05s-1.49-12.15-12.34-10.91-9.55,13.42-9.55,13.42Z",
    style: {
      fill: "#00D35C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.25,
    y: 133.44,
    width: 23.68,
    height: 1.74,
    transform: "translate(234.76 255.2) rotate(173.46)",
    style: {
      fill: "#00D35C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.16 133.43 115.06 132.87 112.54 121.07 107.64 121.63 110.16 133.43",
    style: {
      fill: "#00D35C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.16 133.43 115.06 132.87 112.54 121.07 107.64 121.63 110.16 133.43",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.83,201.71c.2-2.75,3.33-.94,3.33-.94s-3.88-3.7-2.57-6.46,5-.33,5.24-.16c-.2-.2-3.68-3.69-2.08-6.33s5,.23,5.2.43c-.14-.25-1.85-3.54-.18-5.27,2.87-3,8.55,6,11.8,6.81l4.84-3.92a8.38,8.38,0,0,0-.62,4.67c.28,2.29.49,3.82,0,5.18a3,3,0,0,1-2.95,2.09s1.74,2.36.55,4.47c-.62,1.09-2.9,1.07-2.9,1.07a3.61,3.61,0,0,1,.14,3.76c-.94,1.45-3.08,1.21-3.08,1.21s.4,2.45-1,3.62C164.61,214.32,151.4,207.61,151.83,201.71Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.82,189.06l3.51-3.1c.15-.08.31-.17.47-.24,5.37-2.62,12.31.65,9.15,3.56-2.39,2.21-7.76.82-9.89,3.44h0Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.2,208.33a0,0,0,0,1,0,.08,25.71,25.71,0,0,1-13.2-7.72c-.11-.12.05-.35.19-.24A52.8,52.8,0,0,0,168.2,208.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.54,203.41c.06,0,0,.11,0,.1a24.14,24.14,0,0,1-13.88-9.31c-.11-.17,0-.43.1-.25C160.15,197,167.1,201.62,171.54,203.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.83,187.83c3.34,4.52,7.79,7.52,12.8,9.95.06,0,0,.12,0,.11-2.77-.52-5.81-2.4-8-4.06a14.75,14.75,0,0,1-4.86-5.88C160.63,187.85,160.76,187.73,160.83,187.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.6 218.72 146.16 441.31 140.69 441.31 162.58 224.17 105.64 224.17 66.04 441.31 60.51 441.31 101.1 218.72 168.6 218.72",
    style: {
      fill: "#00D35C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.31,
    y: 266.57,
    width: 65.47,
    height: 5.44,
    style: {
      fill: "#00D35C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.5,
    y: 310.71,
    width: 65.47,
    height: 5.44,
    style: {
      fill: "#00D35C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.12,
    y: 354.85,
    width: 70.53,
    height: 5.44,
    style: {
      fill: "#00D35C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.9,
    y: 398.99,
    width: 74.41,
    height: 5.44,
    style: {
      fill: "#00D35C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "168.6 218.72 146.16 441.31 140.69 441.31 162.58 224.17 105.64 224.17 66.04 441.31 60.51 441.31 101.1 218.72 168.6 218.72"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 97.31,
    y: 266.57,
    width: 65.47,
    height: 5.44
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 88.5,
    y: 310.71,
    width: 65.47,
    height: 5.44
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 79.12,
    y: 354.85,
    width: 70.53,
    height: 5.44
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 71.9,
    y: 398.99,
    width: 74.41,
    height: 5.44
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "214.2 459.15 208.66 459.15 164.12 224.17 107.19 224.17 134.01 459.15 128.54 459.15 101.1 218.72 168.63 218.72 214.2 459.15",
    style: {
      fill: "#00D35C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.2 459.15 208.66 459.15 164.12 224.17 107.19 224.17 134.01 459.15 128.54 459.15 101.1 218.72 168.63 218.72 214.2 459.15",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.49,
    y: 212.23,
    width: 73.78,
    height: 6.49,
    style: {
      fill: "#00D35C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.49,
    y: 212.23,
    width: 73.78,
    height: 6.49,
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tools-box--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47.1,
    y: 406.61,
    width: 2.83,
    height: 44.19,
    style: {
      fill: "#00D35C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.35 430.95 83.02 430.14 84.24 429.58 83.63 428.39 84.85 427.83 84.25 426.64 85.46 426.08 84.86 424.89 86.08 424.33 85.47 423.13 86.69 422.58 86.08 421.38 87.3 420.82 86.69 419.63 87.91 419.07 87.31 417.88 88.52 417.32 87.92 416.13 89.14 415.57 88.53 414.38 89.75 413.82 89.14 412.63 90.36 412.07 89.76 410.87 90.97 410.32 90.37 409.12 91.59 408.56 90.98 407.37 92.2 406.81 91.59 405.62 92.81 405.06 92.2 403.87 93.42 403.31 92.82 402.12 94.03 401.56 93.43 400.36 94.65 399.81 94.04 398.61 95.26 398.06 94.65 396.86 95.87 396.3 95.27 395.11 96.48 394.55 95.88 393.36 97.09 392.8 96.49 391.61 97.71 391.05 97.1 389.86 98.32 389.3 97.72 388.1 98.93 387.55 98.33 386.35 99.54 385.8 98.94 384.6 101.27 385.41 85.35 430.95",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.67,
    y: 378.91,
    width: 10.28,
    height: 2.49,
    transform: "matrix(-0.33, 0.94, -0.94, -0.33, 494.27, 409.47)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.35,431l.62-1.77,8.69,3a1.64,1.64,0,0,0,2.09-1l13.9-39.79a1.64,1.64,0,0,0-1-2.09l-8.67-3,.61-1.76,8.67,3a3.51,3.51,0,0,1,2.16,4.47l-13.9,39.79A3.52,3.52,0,0,1,94,434Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.49,
    y: 406.61,
    width: 2.83,
    height: 44.19,
    style: {
      fill: "#00D35C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.93,
    y: 410.12,
    width: 57.71,
    height: 2.27,
    style: {
      fill: "#00D35C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.17,402l15.26-3.31-3.55-16.37L45.62,385.6Zm1.06-5.59-2-9.23,10.93-2.37,2,9.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "67.75 440.89 67.72 440.88 68.68 440.37 68.67 440.32 68.67 440.31 67.65 440.08 68.6 439.56 68.59 439.51 67.56 439.27 68.52 438.76 68.51 438.7 67.48 438.47 68.43 437.95 68.42 437.9 67.39 437.66 68.35 437.15 68.34 437.09 67.32 436.85 68.27 436.33 68.26 436.28 68.26 436.28 67.24 436.04 68.18 435.53 68.18 435.48 67.15 435.24 68.1 434.72 68.1 434.67 68.1 434.67 67.07 434.43 68.02 433.92 68.01 433.87 68.01 433.86 66.99 433.63 67.94 433.11 67.93 433.06 66.91 432.82 67.86 432.31 67.85 432.25 66.82 432.01 67.77 431.5 67.77 431.44 66.74 431.21 67.69 430.7 67.69 430.64 66.66 430.4 67.61 429.89 67.6 429.83 66.58 429.59 67.53 429.08 67.52 429.03 66.49 428.79 67.44 428.28 67.44 428.22 66.41 427.98 67.36 427.47 67.36 427.41 66.33 427.18 67.28 426.67 67.28 426.61 66.25 426.37 67.19 425.86 67.19 425.8 66.17 425.56 67.12 425.05 67.11 425 66.08 424.76 67.03 424.24 67.03 424.19 66 423.95 66.95 423.44 66.95 423.38 65.92 423.14 66.87 422.63 66.87 422.57 65.84 422.33 66.79 421.82 66.78 421.77 65.75 421.53 66.71 421.02 66.7 420.96 65.67 420.73 66.62 420.21 66.61 420.16 65.59 419.92 66.55 419.41 66.54 419.35 65.51 419.12 66.46 418.6 66.46 418.6 66.45 418.54 65.42 418.3 66.38 417.79 66.37 417.74 65.34 417.5 66.3 416.98 66.29 416.93 65.26 416.69 66.21 416.18 66.21 416.13 65.17 415.89 66.13 415.37 66.13 415.32 65.09 415.08 66.05 414.57 66.04 414.52 65.01 414.28 65.97 413.75 65.96 413.71 64.93 413.47 65.89 412.95 65.88 412.9 64.85 412.66 65.8 412.14 65.8 412.09 64.76 411.85 65.72 411.34 65.71 411.29 64.68 411.05 65.64 410.53 65.63 410.48 64.6 410.24 65.56 409.73 65.55 409.67 64.52 409.43 65.47 408.92 65.47 408.87 64.44 408.63 65.39 408.11 65.39 408.06 64.36 407.82 65.31 407.31 65.31 407.26 64.27 407.02 65.22 406.5 65.22 406.44 64.19 406.2 65.15 405.7 65.14 405.64 64.11 405.4 65.06 404.89 65.06 404.83 64.02 404.6 64.98 404.08 64.98 404.03 63.95 403.79 64.91 403.27 64.89 403.22 63.86 402.99 64.82 402.47 64.81 402.42 63.78 402.18 64.73 401.66 64.73 401.61 63.69 401.38 64.65 400.85 64.64 400.81 63.61 400.57 64.57 400.05 64.57 400 63.53 399.76 64.48 399.24 64.43 398.66 49.17 401.97 60.01 442.49 67.75 440.89",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "52.7 415.17 64.35 405.46 64.98 404.93 65.06 404.86 65.06 404.83 64.02 404.6 64.98 404.08 64.98 404.03 63.95 403.79 64.91 403.27 64.89 403.22 63.86 402.99 64.82 402.47 64.81 402.42 64.1 402.25 51.96 412.37 52.7 415.17",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.58 442.17 67.04 441.04 68.07 440.18 67.65 440.08 68.6 439.56 68.59 439.51 67.56 439.27 68.52 438.76 68.51 438.7 67.48 438.47 68.43 437.95 68.42 437.9 67.39 437.66 68.35 437.15 68.34 437.09 67.82 436.97 61.58 442.17",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.8 427.78 67.36 427.47 67.36 427.41 67.26 427.39 66.8 427.78",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.77 437.88 66.76 431.22 66.83 431.16 67.51 430.6 66.66 430.4 67.61 429.89 67.6 429.83 66.58 429.59 67.53 429.08 67.52 429.03 66.49 428.79 67.44 428.28 67.44 428.22 66.52 428.01 58.03 435.08 58.77 437.88",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "51.34 410.08 63.68 399.79 64.08 399.46 64.47 399.13 64.43 398.66 62.48 399.08 50.97 408.68 51.34 410.08",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.36 424.03 66 423.95 66.95 423.44 66.95 423.38 66.3 423.23 56.95 431.03 57.13 431.73 66.36 424.03",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50.71 407.71 60.57 399.5 59.18 399.8 50.52 407.01 50.71 407.71",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.47,419.59H63a2.5,2.5,0,0,1,2.5,2.5v19.24a0,0,0,0,1,0,0H58a0,0,0,0,1,0,0V422.09A2.5,2.5,0,0,1,60.47,419.59Z",
    transform: "translate(237.43 828.25) rotate(164.33)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.98,
    y: 418.03,
    width: 5.05,
    height: 2,
    transform: "matrix(-0.96, 0.27, -0.27, -0.96, 228.04, 806.68)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.52,
    y: 396.89,
    width: 1.6,
    height: 21.57,
    transform: "translate(218.75 785.25) rotate(164.32)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.34,395.91s0-3.46.15-3.49l.52-.15h0l.52-.14c.1,0,1.94,2.9,1.94,2.9l-.29,2-1.53.43Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.26,
    y: 421.08,
    width: 1.31,
    height: 16.81,
    transform: "translate(241.48 825.72) rotate(164.33)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.92,
    y: 421.73,
    width: 1.31,
    height: 16.81,
    transform: "translate(237.06 827.64) rotate(164.33)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.58,
    y: 422.39,
    width: 1.31,
    height: 16.81,
    transform: "translate(232.64 829.57) rotate(164.33)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4,395.95h2.49a2.5,2.5,0,0,1,2.5,2.5v19.24a0,0,0,0,1,0,0h-7.5a0,0,0,0,1,0,0V398.45a2.5,2.5,0,0,1,2.5-2.5Z",
    transform: "translate(20.34 -2.91) rotate(2.85)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.53,
    y: 417.68,
    width: 5.05,
    height: 2,
    transform: "translate(20.93 -2.87) rotate(2.85)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.66,
    y: 419.67,
    width: 1.6,
    height: 21.57,
    transform: "translate(21.53 -2.83) rotate(2.86)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.45,443.2s-1.15,3.26-1.26,3.26l-.53,0h0l-.53,0c-.1,0-.92-3.36-.92-3.36l.92-1.85,1.59.08Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.59,
    y: 398.65,
    width: 1.31,
    height: 16.81,
    transform: "matrix(1, 0.05, -0.05, 1, 20.35, -2.79)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.02,
    y: 398.77,
    width: 1.31,
    height: 16.81,
    transform: "translate(20.36 -2.92) rotate(2.85)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.45,
    y: 398.89,
    width: 1.31,
    height: 16.81,
    transform: "matrix(1, 0.05, -0.05, 1, 20.34, -3.03)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.42,
    y: 399.29,
    width: 6.46,
    height: 40.04,
    transform: "translate(208.94 826.06) rotate(173.12)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.24,
    y: 395.57,
    width: 8.05,
    height: 8.05,
    transform: "translate(201.84 787.06) rotate(173.12)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.82,395.5s7.62-5.47,11.59-5.95l1.66,13.78-12.37-.61Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "93.17 395.92 88.02 403.03 88.01 403.03 84.88 402.88 92.72 392.1 93.17 395.92",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.82,389.66,82.3,402.75l-.6,0-.14-1.17,8.13-11.21A11.81,11.81,0,0,1,91.82,389.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,391.12l-6.62,9.11-.12-1,5.42-7.46C87.13,391.57,87.58,391.33,88,391.12Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 88.86,
    y: 396.23,
    width: 4.93,
    height: 7.7,
    transform: "matrix(0.99, 0.16, -0.16, 0.99, 64.87, -9.44)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,398.94l3.29.53c.51.08,2.8-1.87,4.35-1.62l1.7.27c1.47.24,7.41,2.73,6.79,6.56l-.37,2.28s-.52-2.15-1.85-2.75a2.63,2.63,0,0,0-3.46,1.26,25.71,25.71,0,0,0-1.15,3.34l-6-1a22.64,22.64,0,0,0-.57-4.1c-.38-1.05-3.25-1.27-3.25-1.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.26,
    y: 408.23,
    width: 3.8,
    height: 13.73,
    transform: "translate(67.38 -10.49) rotate(9.16)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.82,
    y: 415.35,
    width: 5.66,
    height: 30.57,
    transform: "matrix(0.99, 0.16, -0.16, 0.99, 69.81, -9.9)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.93,
    y: 420.31,
    width: 57.56,
    height: 30.49,
    style: {
      fill: "#00D35C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.93,423.83c2.79-.11,5.58-.17,8.38-.22s5.58,0,8.37-.06l8.38.06c2.79.05,5.58.1,8.37.22-2.79.13-5.58.18-8.37.23l-8.38.06c-2.79,0-5.58,0-8.37-.06S52.72,424,49.93,423.83Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.58,426.61c3.66-.12,7.32-.18,11-.23l11-.06,11,.06c3.66.05,7.32.11,11,.23-3.66.12-7.32.17-11,.22l-11,.07-11-.07C70.9,426.78,67.24,426.73,63.58,426.61Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.72,430.78c-3.37.12-6.73.17-10.1.22l-10.11.07L67.4,431c-3.37-.05-6.74-.1-10.11-.22,3.37-.12,6.74-.18,10.11-.23l10.11-.06,10.11.07C91,430.6,94.35,430.66,97.72,430.78Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.93,432.45c2.14-.12,4.28-.18,6.42-.22s4.29-.05,6.43-.07,4.28,0,6.42.07,4.28.1,6.43.22c-2.15.12-4.29.18-6.43.22s-4.28.05-6.42.07-4.28,0-6.43-.07S52.07,432.57,49.93,432.45Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "49.93 434.46 56.35 434.32 62.78 434.24 75.63 434.17 88.48 434.24 94.91 434.32 101.33 434.46 94.91 434.6 88.48 434.69 75.63 434.75 62.78 434.68 56.35 434.6 49.93 434.46"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.49,436.05c-2.35.12-4.7.17-7,.22s-4.69,0-7,.07-4.7,0-7.05-.07-4.7-.1-7-.22c2.35-.12,4.7-.18,7-.22s4.7-.05,7.05-.07,4.69,0,7,.07S105.14,435.93,107.49,436.05Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.69,438.49c2.17-.12,4.34-.17,6.51-.22s4.34,0,6.51-.07,4.34,0,6.51.07,4.33.1,6.5.22c-2.17.12-4.33.18-6.5.22s-4.34.05-6.51.07-4.34,0-6.51-.07S73.86,438.61,71.69,438.49Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.93,443c3.58-.12,7.15-.17,10.73-.22l10.72-.07,10.73.07c3.58,0,7.15.1,10.73.22-3.58.12-7.15.18-10.73.22l-10.73.07-10.72-.07C57.08,443.19,53.51,443.13,49.93,443Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M107.49,446.08c-2.4.12-4.8.17-7.2.22s-4.79,0-7.19.07-4.8,0-7.2-.07-4.79-.1-7.19-.22c2.4-.12,4.8-.18,7.19-.23s4.8,0,7.2-.06,4.8,0,7.19.07S105.09,446,107.49,446.08Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.93,448.65c2-.12,4-.18,6-.22s4-.05,6-.07,4,0,6,.07,4,.1,6,.22c-2,.12-4,.17-6,.22s-4,.05-6,.07-4,0-6-.07S51.94,448.77,49.93,448.65Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/maintenance.d44cb03d49225d49ff7c2c94a356813b.svg";
export { ForwardRef as ReactComponent };